import { useLayoutEffect, useState, forwardRef } from "react";

// eslint-disable-next-line react/display-name
export const TopNav = forwardRef((props, ref) => {
	const [navClass, setNavClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [logoClass, setLogoClass] = useState("");

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		// 當螢幕大小超過 640
		if (window.innerWidth > 640) {
			setNavClass("relative flex items-center justify-center py-[48px]");
			setTitleClass("h-auto w-[171px]");
			setLogoClass("absolute left-[26px] top-[41px] h-[30px] w-[30px]");
		} else {
			setNavClass("relative flex items-center justify-center py-[8.5vw]");
			setTitleClass("h-auto w-[27vw]");
			setLogoClass("absolute left-[4vw] top-[7vw] h-[5.5vw] w-[5.5vw]");
		}
	};

	return (
		<div ref={ref} className={navClass}>
			<img
				alt={"brand-title"}
				className={titleClass}
				src={window.assetUrl("/images/liff/brand-title.png")}
			/>
			<img
				alt={"brand-logo"}
				className={logoClass}
				src={window.assetUrl("/images/liff/brand-logo.png")}
			/>
		</div>
	);
});

export const DesktopTopNav = () => {
	return <></>;
};
